export const MainPromptVersion = "main";
export const NextPromptVersion = "next";

export const MAX_USER_MESSAGE_LENGTH = 10000;

export const PromptVersions = [MainPromptVersion, NextPromptVersion] as const;
export type PromptVersion = (typeof PromptVersions)[number];

export enum AssistantSpecialMessages {
  generateSampleTestData = "!generateSampleTestData",
  makeKitchenSink = "!makeKitchenSink",
  sayHello = "!sayHello",
  bigHello = "!bigHello",
  describeScreenshots = "!describeScreenshots",
  addTodoModel = "!addTodoModel",
  addApiKey = "!addApiKey",
  addProductShopifyConnection = "!addProductShopifyConnection",
  addOrderShopifyConnection = "!addOrderShopifyConnection",
  partnerConnect = "!partnerConnect",
  updateGoogleOAuthCredentials = "!updateGoogleOAuthCredentials",
  sleep = "!sleep",
  createOrUpdateFile = "!createOrUpdateFile",
}

/**
 * The number of tokens to keep in the top level conversation messages.
 * This is used to prevent the conversation from getting too long, and
 * triggers a summary generation & removal of old messages if the limit
 * is exceeded.
 **/
export const TOP_LEVEL_CONVERSATION_MAX_TOKENS = 120000;
